import styled from 'styled-components';
import { Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  background: ${Colors.RADISH};
  color: ${Colors.WHITE};
  display: flex;
  flex-direction: column;
  gap: ${Spacing.SINGLE};
  padding: ${Spacing.DOUBLE};
`;

export const Header = styled.div`
  ${Font.bySize(Font.Size.L)}
`;

export const SubContainer = styled.div`
  display: flex;
  gap: ${Spacing.SINGLE};
  ${Font.bySize(Font.Size.XS, Font.Weight.LIGHT)}

  ${Mixins.Media.maxWidthSmall(`
    flex-direction: column;
  `)}
`;

export const SubTextContainer = styled.div`
  display: flex;
  flex: 1 1 100%;
  gap: ${Spacing.SINGLE_HALF};
  line-height: ${Font.LineHeight.S};
  padding: ${Spacing.HALF};
  ${Font.bySize(Font.Size.XS)}
`;

export const IconContainer = styled.div`
  align-items: center;
  display: flex;
`;
